import { render, staticRenderFns } from "./step2.vue?vue&type=template&id=672c2fcc&scoped=true&"
import script from "./step2.vue?vue&type=script&lang=js&"
export * from "./step2.vue?vue&type=script&lang=js&"
import style0 from "./step2.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./step2.vue?vue&type=style&index=1&id=672c2fcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672c2fcc",
  null
  
)

export default component.exports